export const kendoSpanishMessages = {
  // Grid
  'kendo.filter.noRecords': 'No hay datos disponibles.',
  'kendo.filter.filterEqOperator': 'Igual a',
  'kendo.filter.filterNotEqOperator': 'Distinto de',
  'kendo.filter.filterContainsOperator': 'Contiene',
  'kendo.filter.filterNotContainsOperator': 'No contiene',
  'kendo.filter.filterStartsWithOperator': 'Empieza con',
  'kendo.filter.filterEndsWithOperator': 'Termina con',
  'kendo.filter.filterIsNullOperator': 'Es nulo',
  'kendo.filter.filterIsNotNullOperator': 'No es nulo',
  'kendo.filter.filterIsEmptyOperator': 'Está vacío',
  'kendo.filter.filterIsNotEmptyOperator': 'No está vacío',
  'kendo.filter.filterGteOperator': 'Mayor o igual que',
  'kendo.filter.filterGtOperator': 'Mayor que',
  'kendo.filter.filterLteOperator': 'Menor o igual que',
  'kendo.filter.filterLtOperator': 'Menor que',
  'kendo.filter.filterBeforeOperator': 'Antes que',
  'kendo.filter.filterBeforeOrEqualOperator': 'Antes o igual que',
  'kendo.filter.filterAfterOperator': 'Después que',
  'kendo.filter.filterAfterOrEqualOperator': 'Después o igual que',
  'kendo.filter.filterAndLogic': 'Y',
  'kendo.filter.filterOrLogic': 'O',
  'kendo.filter.filterBooleanTrue': 'Verdadero',
  'kendo.filter.filterBooleanFalse': 'Falso',
  'kendo.filter.filterClearButton': 'Limpiar',
  'kendo.filter.filterSubmitButton': 'Aplicar',
  'kendo.filter.addFilter': 'Añadir filtro',
  'kendo.filter.addGroup': 'Añadir grupo',

  // Pager
  'kendo.pager.firstPage': 'Ir a la primera página',
  'kendo.pager.previousPage': 'Ir a la página anterior',
  'kendo.pager.nextPage': 'Ir a la página siguiente',
  'kendo.pager.lastPage': 'Ir a la última página',
  'kendo.pager.page': 'Página',
  'kendo.pager.of': 'de',
  'kendo.pager.itemsPerPage': 'registros por página',
  'kendo.pager.items': 'registros',
  'kendo.pager.noItems': 'No hay registros',

  // List (ListBox / DropDownList)
  'kendo.list.noData': 'No se encontraron datos.',
  'kendo.list.clear': 'Limpiar selección',
  'kendo.list.select': 'Seleccione...',
  'kendo.list.loading': 'Cargando...',
  'kendo.list.singleSelection': 'Un solo item seleccionado',
  'kendo.list.multipleSelection': '{0} registrosseleccionados',

  // fileselect
  'kendo.fileselect.select': 'Seleccionar',
  'kendo.fileselect.dropFilesHere': 'Arrastrar fichero aquí',

  //kendo grid
  "kendo.grid.groupPanelEmpty": "Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio",
  "kendo.grid.noRecords": "No hay datos disponibles.",
  "kendo.grid.pagerFirstPage": "Ir a la primera página",
  "kendo.grid.pagerPreviousPage": "Ir a la página anterior",
  "kendo.grid.pagerNextPage": "Ir a la página siguiente",
  "kendo.grid.pagerLastPage": "Ir a la última página",
  "kendo.grid.pagerPage": "Página",
  "kendo.grid.pagerOf": "de",
  "kendo.grid.pagerItems": "registros",
  "kendo.grid.pagerItemsPerPage": "registros por página",
  "kendo.grid.pagerPageNumberInputTitle": "Número de página",
  "kendo.grid.filter": "Filtrar",
  "kendo.grid.filterEqOperator": "Es igual a",
  "kendo.grid.filterNotEqOperator": "No es igual a",
  "kendo.grid.filterIsNullOperator": "Es nulo",
  "kendo.grid.filterIsNotNullOperator": "No es nulo",
  "kendo.grid.filterIsEmptyOperator": "Está vacío",
  "kendo.grid.filterIsNotEmptyOperator": "No está vacío",
  "kendo.grid.filterStartsWithOperator": "Comienza con",
  "kendo.grid.filterContainsOperator": "Contiene",
  "kendo.grid.filterNotContainsOperator": "No contiene",
  "kendo.grid.filterEndsWithOperator": "Termina en",
  "kendo.grid.filterGteOperator": "Es mayor o igual que",
  "kendo.grid.filterGtOperator": "Es mayor que",
  "kendo.grid.filterLteOperator": "Es menor o igual que",
  "kendo.grid.filterLtOperator": "Es menor que",
  "kendo.grid.filterIsTrue": "Sí",
  "kendo.grid.filterIsFalse": "No",
  "kendo.grid.filterBooleanAll": "(Todas)",
  "kendo.grid.filterAfterOrEqualOperator": "Es posterior o igual a",
  "kendo.grid.filterAfterOperator": "Es posterior",
  "kendo.grid.filterBeforeOperator": "Es anterior",
  "kendo.grid.filterBeforeOrEqualOperator": "Es anterior o igual a",
  "kendo.grid.filterFilterButton": "Filtrar",
  "kendo.grid.filterClearButton": "Limpiar filtros",
  "kendo.grid.filterAndLogic": "Y",
  "kendo.grid.filterOrLogic": "O",
  "kendo.grid.filterDateToggle": "Mostrar calendario",
  "kendo.grid.filterDateToday": "Hoy",
  "kendo.grid.filterNumericDecrement": "Disminuir valor",
  "kendo.grid.filterNumericIncrement": "Incrementar valor",
  "kendo.grid.loading": "Cargando",
  "kendo.grid.columns": "Columnas",
  "kendo.grid.lock": "Bloquear",
  "kendo.grid.unlock": "Desbloquear",
  "kendo.grid.stick": "Fijar",
  "kendo.grid.unstick": "Desfijar",
  "kendo.grid.setColumnPosition": "Establecer posición de columna",
  "kendo.grid.sortAscending": "Orden ascendente",
  "kendo.grid.sortDescending": "Orden descendente",
  "kendo.grid.columnsApply": "Aplicar",
  "kendo.grid.columnsReset": "Restablecer",
  "kendo.grid.sortable": "Ordenable",
  "kendo.grid.sortedAscending": "Ordenado ascendentemente",
  "kendo.grid.sortedDescending": "Ordenado descendentemente",
  "kendo.grid.sortedDefault": "No ordenado",
  "kendo.grid.filterInputLabel": "{columnName} filtro",
  "kendo.grid.filterMenuTitle": "{columnName} menú de filtro",
  "kendo.grid.filterMenuOperatorsDropDownLabel": "{columnName} operadores de filtro",
  "kendo.grid.filterMenuLogicDropDownLabel": "{columnName} lógica de filtro",
  "kendo.grid.columnMenu": "{columnName} menú de columna",
  "kendo.grid.selectionCheckboxLabel": "Seleccionar fila",
  "kendo.grid.selectAllCheckboxLabel": "Seleccionar todas las filas",
  "kendo.grid.pagerLabel": "Navegación de página, página {currentPage} de {totalPages}",
  "kendo.grid.gridLabel": "Tabla de datos",
  "kendo.grid.groupCollapse": "Contraer grupo",
  "kendo.grid.groupExpand": "Expandir grupo",
  "kendo.grid.detailCollapse": "Contraer detalles",
  "kendo.grid.detailExpand": "Expandir detalles",
  "kendo.grid.autosizeThisColumn": "Ajustar tamaño de esta columna",
  "kendo.grid.autosizeAllColumns": "Ajustar tamaño de todas las columnas",
  "kendo.grid.pagerSelectPage": "Seleccionar página",
  "kendo.grid.topToolbarLabel": "Barra de herramientas superior",
  "kendo.grid.bottomToolbarLabel": "Barra de herramientas inferior",
  "kendo.grid.groupPanelLabel": "Panel de grupo",
  "kendo.grid.dragRowHandleLabel": "Arrastrar fila",
  "kendo.grid.selectRowCheckboxLabel": "Seleccionar fila",
  "kendo.grid.selectAllRowsCheckboxLabel": "Seleccionar todas las filas",
  "kendo.grid.filterCellOperatorLabel": "Operadores de celda de filtro para {columnName}",
  "kendo.grid.booleanFilterCellLabel": "Celda de filtro booleano para {columnName}",
  "kendo.grid.columnMenuFilterTabTitle": "Filtro",
  "kendo.grid.columnMenuGeneralTabTitle": "General",
  "kendo.grid.columnMenuColumnsTabTitle": "Columnas",
  "kendo.grid.groupChipMenuPrevious": "Mover antes",
  "kendo.grid.groupChipMenuNext": "Mover después",
  "kendo.grid.pagerInputLabel": "Escriba un número de página",
  "kendo.grid.formValidationErrorText": "El campo {fieldName} tiene un error de validación {errorName}",
  "kendo.grid.removeConfirmationDialogTitle": "Por favor confirme",
  "kendo.grid.removeConfirmationDialogContent": "¿Está seguro de que desea eliminar este elemento?",
  "kendo.grid.removeConfirmationDialogConfirmText": "Sí",
  "kendo.grid.removeConfirmationDialogRejectText": "No",
  "kendo.grid.externalEditingTitle": "Editar",
  "kendo.grid.externalEditingSaveText": "Guardar",
  "kendo.grid.externalEditingCancelText": "Cancelar",
  "kendo.grid.sortClearButton": "Borrar ordenación",
  "kendo.grid.adaptiveCloseButtonTitle": "Cerrar",
  "kendo.grid.adaptiveBackButtonTitle": "Atrás",
  "kendo.grid.filterClearAllButton": "Borrar todos los filtros",
  "kendo.grid.sortDoneButton": "Listo",
  "kendo.grid.columnsSubtitle": "Los campos seleccionados son visibles",
  "kendo.grid.adaptiveFilterTitle": "Filtrar por",
  "kendo.grid.adaptiveFilterOperatorsTitle": "Operadores",
  "kendo.grid.adaptiveSortTitle": "Ordenar por",
  "kendo.grid.externalEditingAddTitle": "Agregar",
  "kendo.grid.adaptiveGroupTitle": "Agrupar por",
  "kendo.grid.groupClearButton": "Borrar agrupación",
  "kendo.grid.groupToolbarToolText": "Agrupar",
  "kendo.grid.groupDoneButton": "Listo",
  "kendo.grid.aiAssistantToolbarToolText": "Asistente IA",
  "kendo.grid.aiAssistantWindowTitle": "Asistente IA",
  "kendo.grid.aiAssistantApplyButtonText": "Aplicar",
  "kendo.grid.aiAssistantWindowCloseTitle": "Cerrar",
  "kendo.grid.aiAssistantWindowMaximizeTitle": "Maximizar",
  "kendo.grid.aiAssistantWindowMinimizeTitle": "Minimizar",
  "kendo.grid.aiAssistantWindowRestoreTitle": "Restaurar",
  "kendo.grid.aiAssistantOutputCardTitle": "Generado con IA",
  "kendo.grid.aiAssistantOutputCardBodyContent": "La operación se realizó con éxito. Los datos son:"


};
